export default __webpack_public_path__ + "static/media/login.07d83e33.mp3";